import { Omit } from '@/utils/typescript/types';
export interface IGridOptions extends Omit<tuiGrid.IGridOptions, 'el'> {}
export const DefaultGridOptions: IGridOptions = {
    bodyHeight: 'fitToParent',
    rowHeight: 40,
    minRowHeight: 40,
    virtualScrolling: true,
    
    columns: [],
};

export const DefaultColumnOptions = {
    minWidth: 150,
    align: 'right',
    resizable: true,
};

export const GroupColumnOptions = {
    minWidth: 280,
    align: 'right',
    resizable: true,
};

export const NumberColumnOptions = {
    minWidth: 200,
    align: 'right',
    resizable: true,
};
